export const kinderConnectCaptureSettingsSubmitButton = 'kinder-connect-capture-settings-submit-button';
export const kinderConnectCaptureSettingsCaptureConsequences = 'kinder-connect-capture-settings-capture-consequences';
